/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const StatusChange = {
    Add: 'Add',
    Remove: 'Remove'
} as const;
export type StatusChange = typeof StatusChange[keyof typeof StatusChange];


export function instanceOfStatusChange(value: any): boolean {
    for (const key in StatusChange) {
        if (Object.prototype.hasOwnProperty.call(StatusChange, key)) {
            if (StatusChange[key as keyof typeof StatusChange] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StatusChangeFromJSON(json: any): StatusChange {
    return StatusChangeFromJSONTyped(json, false);
}

export function StatusChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusChange {
    return json as StatusChange;
}

export function StatusChangeToJSON(value?: StatusChange | null): any {
    return value as any;
}

export function StatusChangeToJSONTyped(value: any, ignoreDiscriminator: boolean): StatusChange {
    return value as StatusChange;
}

